import { createContext, type ReactNode, useContext } from 'react';
import type { ApiClient } from '../api/client';
import type { Session } from './session';

interface Services {
  session: Session;
  api: ApiClient;
}

const ServicesContext = createContext<Services | null>(null);

/** Injects the session and API client, created once at startup in main.tsx. */
export function ServicesProvider({ value, children }: { value: Services; children: ReactNode }) {
  return <ServicesContext.Provider value={value}>{children}</ServicesContext.Provider>;
}

function useServices(): Services {
  const services = useContext(ServicesContext);
  if (!services) throw new Error('ServicesProvider is missing');
  return services;
}

export const useSession = (): Session => useServices().session;
export const useApi = (): ApiClient => useServices().api;
